export const eventTypeLabels = { WORKSHOP: 'Workshop', WEBINAR: 'Webinar', HACKATHON: 'Hackathon' };
export const eventTypeColors = { WORKSHOP: 'primary', WEBINAR: 'secondary', HACKATHON: 'success' };
export const getEventTypeLabel = (type) => eventTypeLabels[type] || type;
export const getEventTypeColor = (type) => eventTypeColors[type] || 'default';
